import { useEffect, useState } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { supabase } from "../lib/supabase";

const ProtectedCourseAuthorRoute = ({ children }) => {
  const { courseId, id } = useParams();
  const targetCourseId = courseId || id;
  const location = useLocation();
  const { user, loading, profileLoading } = useAuth();
  const [access, setAccess] = useState({
    loading: true,
    allowed: false,
    courseId: null,
    userId: null,
  });

  useEffect(() => {
    if (loading || profileLoading) return;
    if (!user || !targetCourseId) {
      setAccess({
        loading: false,
        allowed: false,
        courseId: targetCourseId || null,
        userId: user?.id || null,
      });
      return;
    }
    let active = true;
    setAccess({
      loading: true,
      allowed: false,
      courseId: targetCourseId,
      userId: user.id,
    });
    supabase
      .rpc("can_preview_course", { p_course_id: targetCourseId })
      .then(({ data, error }) => {
        if (!active) return;
        setAccess({
          loading: false,
          courseId: targetCourseId,
          userId: user.id,
          allowed: !error && data === true,
        });
      });
    return () => {
      active = false;
    };
  }, [loading, profileLoading, targetCourseId, user]);

  if (
    loading ||
    profileLoading ||
    access.loading ||
    access.courseId !== (targetCourseId || null) ||
    access.userId !== (user?.id || null)
  ) {
    return <div className="min-h-screen bg-dm-page" />;
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (!access.allowed) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default ProtectedCourseAuthorRoute;
